import { Layout } from '@jjj/components';
import styled from 'styled-components';
import { palette } from 'styled-theme';

const { Content, Footer } = Layout;

export const AppContent = styled(Content)`
  position: relative;
  flex-shrink: 0;
  background: ${palette('background', 0)};
`;

export const AppFooter = styled(Footer)`
  background: ${palette('grayscale', 5)} !important;
  border-top: 1px solid ${palette('grayscale', 3)} !important;
  color: ${palette('secondary', 0)} !important;
  flex-direction: row-reverse;
  display: flex;
  height: 60px;
  padding: 10px !important;
`;
